import type { ICustomControlProcedureDiagnosticReportReadProps } from '../../interfaces/';
import { ProcedureDiagnosticReportReadButtons } from '../../../../elements/carePathButtons/ProcedureDiagnosticReportReadButtons';
import { TpoV1DiagnosticReportRead } from './TpoV1DiagnosticReportRead';
import { TpoV1ProcedureRead } from './TpoV1ProcedureRead';

export function TpoV1ProcedureDiagnosticReportRead(props: ICustomControlProcedureDiagnosticReportReadProps) {
    return (
        <>
            <TpoV1ProcedureRead
                isFirstItem={props.isFirstItem}
                isLastItem={false}
                itemState={props.itemState}
                procedure={props.procedure}
                process={props.process}
                request={props.request}
                serviceCode={props.serviceCode}
                supervision={props.supervision}
                updateItemState={props.updateItemState}
            />

            <TpoV1DiagnosticReportRead
                diagnosticReport={props.diagnosticReport}
                isFirstItem={props.isFirstItem}
                isLastItem={props.isLastItem}
                itemState={props.reportItemState}
                process={props.process}
                processButtons={<ProcedureDiagnosticReportReadButtons {...props} />}
                request={props.request}
                scrollToProcessItem={props.scrollToProcessItem}
                serviceCode={props.serviceCode}
                setHideCreateActions={props.setHideCreateActions}
                updateItemState={props.updateReportItemState}
            />
        </>
    );
}
